import { useEffect } from 'react';
import { setLocalization } from '@/utils/i18n';
import useStore from '@/store/useStore';

function useStaticPageSetData(pageData) {
  const setBuilderData = useStore(state => state.setBuilderData);

  const { locale } = pageData;

  setLocalization(locale!);

  useEffect(() => {
    const headerBannerData = pageData?.headerBanner?.data;
    setBuilderData([
      [headerBannerData],
      {
        topPurpleBar: pageData.promotions.topPurpleBar,
        topNav: pageData.promotions.topNav,
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useStaticPageSetData;
